import zxcvbn from 'zxcvbn';

export const REGEXP_PASS_FAIR = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const REGEXP_PASS_STRONG =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*?[!@#\$&*~)(]).{8,}$/;

export const REGEXP_EMAIL =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export enum PASSWORD_STRENGTH {
  WEAK = 'weak',
  FAIR = 'fair',
  STRONG = 'strong',
}

export const validateEmail = (email: string) => {
  return REGEXP_EMAIL.test(email);
};

export const getPasswordStength = (password: string) => {
  const testPassword = zxcvbn(password);
  const score = (testPassword.score * 100) / 4;
  const passwordLength = (password || '').length;
  console.log('score', score);
  if (score < 25) {
    return PASSWORD_STRENGTH.WEAK;
  }
  if (score >= 25 && score < 50) {
    return PASSWORD_STRENGTH.FAIR;
  }

  if (score >= 50) {
    if (password.match(REGEXP_PASS_STRONG)) {
      return PASSWORD_STRENGTH.STRONG;
    } else {
      return PASSWORD_STRENGTH.FAIR;
    }
  }
  // const passwordLength = (password || '').length;
  // if (password.match(REGEXP_PASS_STRONG)) {
  //   return PASSWORD_STRENGTH.STRONG;
  // }
  // if (password.match(REGEXP_PASS_FAIR)) {
  //   return PASSWORD_STRENGTH.FAIR;
  // }
  // if (passwordLength && passwordLength < 8) {
  //   return PASSWORD_STRENGTH.WEAK;
  // }
  return undefined;
};

export const getErrorObject = (error: string) => ({
  message: error,
});
